module.exports = __webpack_public_path__ + "static/media/tdlr2.dbf984a8.png";